// extracted by mini-css-extract-plugin
module.exports = {"row":"offline_row_ehN5o","img":"offline_img_ORl4Z"};